import { render, staticRenderFns } from "./GalleryStockPhotos.vue?vue&type=template&id=cd094ef8&scoped=true"
import script from "./GalleryStockPhotos.ts?vue&type=script&lang=ts&external"
export * from "./GalleryStockPhotos.ts?vue&type=script&lang=ts&external"
import style0 from "./GalleryStockPhotos.scss?vue&type=style&index=0&id=cd094ef8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd094ef8",
  null
  
)

export default component.exports